import { Select, Typography } from "antd";
import { BookingUserSelect } from "./BookingUserSelect";
import { BookingUser } from "lib/bookingUsers";
import { getBookingFilterMessages } from "i18n/bookingFilters";
import { useIntl } from "react-intl";
import "./BookingFilters.css";

export const BookingFilters = ({
  cities,
  users,
  selectedCity,
  selectedUserId,
  selectedUserLabel,
  onCityChange,
  onSpecialistChange,
  isLoading,
  isError,
  onRetry,
}: {
  cities: string[];
  users: BookingUser[];
  selectedCity: string;
  selectedUserId: string;
  selectedUserLabel: string;
  onCityChange: (city: string) => void;
  onSpecialistChange: (userId: string) => void;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
}) => {
  const { locale } = useIntl();
  const copy = getBookingFilterMessages(locale);
  return (
    <div className="booking-filters">
      <div>
        <Typography.Text strong>{copy.city}</Typography.Text>
        <Select
          aria-label={copy.city}
          showSearch
          allowClear
          optionFilterProp="label"
          style={{ width: "100%", marginTop: 5 }}
          value={selectedCity || undefined}
          placeholder={copy.anyCity}
          onChange={(city) => onCityChange(city || "")}
          options={[{ value: "", label: copy.anyCity }, ...cities.map((city) => ({ value: city, label: city }))]}
        />
        {selectedUserId && !isLoading && !isError && !cities.length && (
          <Typography.Text role="status">{copy.noCities}</Typography.Text>
        )}
      </div>
      <BookingUserSelect
        users={users}
        value={selectedUserId}
        selectedLabel={selectedUserLabel}
        onChange={onSpecialistChange}
        isLoading={isLoading}
        isError={isError}
        onRetry={onRetry}
        emptyMessage={selectedCity ? copy.noSpecialistsInCity : copy.noSpecialists}
      />
    </div>
  );
};
